export default __webpack_public_path__ + "static/media/draw.7e5e0d22.png";